/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const verifyNativeLoginBodyTwoCodeRegExp = new RegExp('^\\d{6}$');

export const VerifyNativeLoginBody = zod
  .object({
    authMethod: zod.enum(['code', 'password']).optional(),
    channel: zod.enum(['email', 'phone']),
    csrfToken: zod.string(),
    expiresAt: zod.iso.datetime({ offset: true }),
    flowId: zod.string().min(1),
    flowKind: zod.enum(['login', 'registration', 'recovery']),
    homeRegion: zod
      .enum(['au', 'us'])
      .optional()
      .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States)."),
    identifier: zod.string().min(1),
    registrationTraits: zod
      .object({
        email: zod.email(),
        name: zod.object({
          first: zod.string().min(1),
          last: zod.string().min(1),
        }),
        phone_number: zod.string().min(1),
      })
      .optional(),
    sessionTokenExchangeCode: zod.string().optional(),
  })
  .and(
    zod.object({
      app: zod
        .enum(['onearly', 'strongermemory'])
        .optional()
        .describe(
          "The app signing in. Core mints the tokens for that app's own Ory client where this deployment has one, else for the OnEarly app's. The access token names the client in `client_id`: refresh and revoke at Ory with that client. Defaults to `onearly`, so existing clients need not send it. It also decides whose sign-up regions apply: a request naming `onearly` takes everyone's, whatever headers it carries.",
        ),
      code: zod.string().regex(verifyNativeLoginBodyTwoCodeRegExp),
    }),
  );

export type VerifyNativeLoginBody = zod.input<typeof VerifyNativeLoginBody>;
export type VerifyNativeLoginBodyOutput = zod.output<typeof VerifyNativeLoginBody>;
